import Modal from "react-modal"
import { faClipboardCheck, faSearch, faTimes, faTruckFast, faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useEffect, useState } from "react"
import { Input } from "../../components/Input"
import { Load } from "../../components/Load"
import { IEntregas, IFilterEntregasDTO, IPessoas, IVeiculos } from "../../global/types"
import { useAdmContext } from "../../hooks/useAdmContext"
import { api } from "../../services/api"
import { compareInHoursAndMin, convertDateSqlToDate, convertDateToBr, convertToUs, minutesToHours } from "../../utils/dateProvider"
import "./style.css"
import { defaultModalStyle } from "../../utils/defaultModalStyle"
import { VeiculosModal } from "../../modals/VeiculosModal"
import { PessoasModal } from "../../modals/PessoasModal"
import { Pagination } from "../../components/Pagination"
import { currencyFormatter } from "../../utils/currencyFormatter"
import { maskNumber } from "../../utils/masks"
import {
  custoFreelancers,
  custoKmRodado,
  custoPorPedido,
  dieselGasto,
  minutosExtras,
  minutosPorKm,
  minutosPorPedido,
  porcCusto,
  qtdDiarias,
  salarioDia,
  totalDiaAjudantes,
  totalExtraAjudantes,
  totalGasto,
  valorHrExtra
} from "../../utils/calculos"
import { DetalheEntregaModal } from "../../modals/DetalheEntregaModal"

const defaultFilters: IFilterEntregasDTO = {
  veiculo: {} as IVeiculos,
  motorista: {} as IPessoas,
  ajudante: {} as IPessoas,
  finalizados: true,
  data: "",
  entrada: "",
  saida: "",
  dataBetween_inicio: "",
  dataBetween_final: ""
}

export function Lista() {
  const { tokens, checkToken } = useAdmContext()

  const [loading, setLoading] = useState(false)
  const [txtLoading, setTxtLoading] = useState("")

  const [list, setList] = useState<IEntregas[]>([])

  const [pesquisa, setPesquisa] = useState<IFilterEntregasDTO>(defaultFilters)

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  // const [limitPage, setLimitPage] = useState(25);
  const limitPage = 25

  const [modalVeiculo, setModalVeiculo] = useState(false)
  const [modalMotorista, setModalMotorista] = useState(false)
  const [modalAjudante, setModalAjudante] = useState(false)
  const [modalDetalhe, setModalDetalhe] = useState(false)

  const [detalheEntrega, setDetalheEntrega] = useState<IEntregas>({} as IEntregas)

  const handleSelectVeiculo = (veiculo: IVeiculos) => {
    setPesquisa(e => ({ ...e, veiculo }))
  }

  const handleSelectMotorista = (motorista: IPessoas) => {
    setPesquisa(e => ({ ...e, motorista }))
  }

  const handleSelectAjudante = (ajudante: IPessoas) => {
    setPesquisa(e => ({ ...e, ajudante }))
  }

  const handleOpenDetalhe = (item: IEntregas) => {
    setDetalheEntrega(item)
    setModalDetalhe(true)
  }

  const loadList = useCallback(async (pesq?: IFilterEntregasDTO) => {
    setLoading(true)
    setTxtLoading("Carregando lista de Entregas...")

    const canLoad = await checkToken()
    if (!canLoad)
      return

    await api.post("entregas/all", {
      cursor: (limitPage * page) - limitPage,
      limit: limitPage,
      pesquisa: {
        id_veiculo: pesq?.veiculo ? pesq?.veiculo.id : null,
        id_motorista: pesq?.motorista ? pesq?.motorista.id : null,
        id_ajudante: pesq?.ajudante ? pesq?.ajudante.id : null,
        entrada: null,
        saida: null,
        dataBetween: pesq?.dataBetween_inicio && pesq?.dataBetween_final ? {
          inicio: `${convertToUs(pesq?.dataBetween_inicio)} 00:00:00`,
          final: `${convertToUs(pesq?.dataBetween_final)} 23:59:59`
        } : null,
        finalizados: true
      }
    })
      .then((res) => {
        if (!res.data)
          return

        setList(res.data.result)

        const newMaxPage = Math.ceil(res.data.total / limitPage);
        setMaxPage(newMaxPage < 1 ? 1 : newMaxPage);
      })
      .catch((err) => {
        if (err.response?.data?.message)
          alert(err.response.data.message)
        else
          alert("Erro ao carregar lista de entregas. Tente novamente mais tarde")
      })
      .finally(() => {
        setLoading(false)
        setTxtLoading("")
      })
  }, [checkToken, page])

  useEffect(() => {
    if (tokens?.token)
      loadList()
  }, [tokens, page, loadList])

  useEffect(() => {
    Modal.setAppElement("body")
  }, [])

  return (
    <div id="pgLista">

      {loading && (
        <Load txtLoading={txtLoading} />
      )}

      {!loading && (
        <>
          <div className="painel">
            <p className="title">Pesquisa</p>

            <div className="bodyFilter">

              <div style={{ width: "32%" }} >
                <label>Veículo:</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={pesquisa.veiculo?.nome ? pesquisa.veiculo.nome : ""}
                    inputMaskChange={(v) => { }}
                    placeholder="Pesquisa por Veículo"
                    readOnly
                  />
                  {pesquisa.veiculo?.nome && (
                    <button className="btn-red" onClick={() => setPesquisa(e => ({ ...e, veiculo: {} as IVeiculos }))}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button className="btn-purple" onClick={() => setModalVeiculo(true)}>
                    <FontAwesomeIcon icon={faTruckFast} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Motorista:</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={pesquisa.motorista?.nome ? pesquisa.motorista.nome : ""}
                    inputMaskChange={(v) => { }}
                    placeholder="Pesquisa por Motorista"
                    readOnly
                  />
                  {pesquisa.motorista?.nome && (
                    <button className="btn-red" onClick={() => setPesquisa(e => ({ ...e, motorista: {} as IPessoas }))}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button className="btn-purple" onClick={() => setModalMotorista(true)}>
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Ajudante:</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={pesquisa.ajudante?.nome ? pesquisa.ajudante.nome : ""}
                    inputMaskChange={(v) => { }}
                    placeholder="Pesquisa por Ajudante"
                    readOnly
                  />
                  {pesquisa.ajudante?.nome && (
                    <button className="btn-red" onClick={() => setPesquisa(e => ({ ...e, ajudante: {} as IPessoas }))}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button className="btn-purple" onClick={() => setModalAjudante(true)}>
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Data Inicial</label>
                <Input
                  mask="date"
                  value={pesquisa.dataBetween_inicio}
                  inputMaskChange={(v) => setPesquisa(e => ({ ...e, dataBetween_inicio: v }))}
                  placeholder="Pesquisa por Data"
                  maxLength={10}
                />
              </div>

              <div style={{ width: "32%" }}>
                <label>Data Final</label>
                <Input
                  mask="date"
                  value={pesquisa.dataBetween_final}
                  inputMaskChange={(v) => setPesquisa(e => ({ ...e, dataBetween_final: v }))}
                  placeholder="Pesquisa por Data"
                  maxLength={10}
                />
              </div>

              <div style={{ width: "100%" }}>
                <button className="btn-blue" style={{ margin: "0 auto" }} onClick={() => loadList(pesquisa)}>
                  <FontAwesomeIcon icon={faSearch} />
                  Pesquisar
                </button>
              </div>

            </div>
          </div>

          <div className="painel table">

            <div className="dvScroll">

              <div className="head">
                <span style={{ width: "50px" }}></span>
                <span style={{ width: "100px" }}>Roteiro</span>
                <span style={{ width: "100px" }}>Data</span>
                <span style={{ width: "170px" }}>Veículo</span>
                <span style={{ width: "170px" }}>Motorista</span>
                <span style={{ width: "170px" }}>Ajudante</span>
                <span style={{ width: "170px" }}>Freelancers</span>
                <span style={{ width: "170px" }}>Cidades</span>
                <span style={{ width: "100px", textAlign: "right" }}>Carga</span>
                <span style={{ width: "70px", textAlign: "right" }}>Pedidos</span>
                <span style={{ width: "70px", textAlign: "center" }}>Entrada</span>
                <span style={{ width: "70px", textAlign: "center" }}>Saída</span>
                <span style={{ width: "70px", textAlign: "center" }}>Hr. Trab.</span>
                <span style={{ width: "80px", textAlign: "right" }}>Km Inicial</span>
                <span style={{ width: "70px", textAlign: "right" }}>Km Final</span>
                <span style={{ width: "90px", textAlign: "right" }}>Km Rodado</span>
                <span style={{ width: "100px", textAlign: "center" }}>Temp. Ped</span>
                <span style={{ width: "80px", textAlign: "center" }}>Temp. Km</span>
                <span style={{ width: "90px", textAlign: "right" }}>Diesel</span>
                <span style={{ width: "80px", textAlign: "right" }}>Diárias</span>
                <span style={{ width: "80px", textAlign: "right" }}>Motorista</span>
                <span style={{ width: "90px", textAlign: "right" }}>Ajudante(s)</span>
                <span style={{ width: "110px", textAlign: "center" }}>Hr. Extra Mot.</span>
                <span style={{ width: "110px", textAlign: "right" }}>Extra Mot.</span>
                <span style={{ width: "110px", textAlign: "right" }}>Extra Ajud.(s)</span>
                <span style={{ width: "110px", textAlign: "right" }}>Extra Total</span>
                <span style={{ width: "110px", textAlign: "right" }}>Freelancers</span>
                <span style={{ width: "110px", textAlign: "right" }}>Pedágio</span>
                <span style={{ width: "110px", textAlign: "right" }}>Balsa</span>
                <span style={{ width: "110px", textAlign: "right" }}>Diversos</span>
                <span style={{ width: "110px", textAlign: "right" }}>Total Gastos</span>
                <span style={{ width: "110px", textAlign: "right" }}>Custo Km Rod</span>
                <span style={{ width: "110px", textAlign: "right" }}>Custo Entrega</span>
                <span style={{ width: "110px", textAlign: "right" }}>Porc. Custo</span>
              </div>

              <div className="tableContent">
                {list && list.map(item => (
                  // #b9e5b4 Verde para quando estiver finalizado
                  <div className="rowTable" key={item.id}>
                    <span style={{ width: "50px", textAlign: "center" }}>
                      <FontAwesomeIcon
                        icon={faClipboardCheck}
                        fontSize="25px"
                        color="#00e0aa"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenDetalhe(item)}
                      />
                    </span>
                    <span style={{ width: "100px" }}>{maskNumber(`${item.roteiro}`)}</span>
                    <span style={{ width: "100px" }}>{convertDateToBr(convertDateSqlToDate(`${item.data}`))}</span>
                    <span style={{ width: "170px" }}>{item.veiculo.nome}</span>
                    <span style={{ width: "170px" }}>{item.motorista.nome}</span>
                    <span style={{ width: "170px" }}>
                      {item.ajudante ? item.ajudante.nome : ""}
                      {item.freelancers && item.freelancers.filter(e => e.funcao === 0).map((rs, i) => (
                        i > 0 || item.ajudante?.nome ? ` / ${rs.pessoa.nome}` : rs.pessoa.nome
                      ))}
                    </span>
                    <span style={{ width: "170px" }}>
                      {item.freelancers && item.freelancers.filter(e => e.funcao === 1).map((rs, i) => (
                        i > 0 ? ` / ${rs.pessoa.nome}` : rs.pessoa.nome
                      ))}
                    </span>
                    <span style={{ width: "170px" }}>
                      {item.cidades && item.cidades.map((rs, i) => (
                        i > 0 ? `/${rs.cidade.nome}` : rs.cidade.nome
                      ))}
                    </span>
                    <span style={{ width: "100px", textAlign: "right" }}>{currencyFormatter(parseFloat(`${item.valor_carga}`))}</span>
                    <span style={{ width: "70px", textAlign: "right" }}>{maskNumber(`${item.pedidos}`)}</span>
                    <span style={{ width: "70px", textAlign: "center" }}>{`${item.entrada}`.slice(0, 5)}</span>
                    <span style={{ width: "70px", textAlign: "center" }}>{`${item.saida}`.slice(0, 5)}</span>
                    <span style={{ width: "70px", textAlign: "center" }}>{compareInHoursAndMin(`${item.entrada}`, `${item.saida}`)}</span>
                    <span style={{ width: "80px", textAlign: "right" }}>{maskNumber(`${item.km_inicial}`)}</span>
                    <span style={{ width: "70px", textAlign: "right" }}>{maskNumber(`${item.km_final}`)}</span>
                    <span style={{ width: "90px", textAlign: "right" }}>{maskNumber(`${parseInt(`${item.km_final}`) - parseInt(`${item.km_inicial}`)}`)}</span>
                    <span style={{ width: "100px", textAlign: "center" }}>{minutosPorPedido(item)}</span>
                    <span style={{ width: "80px", textAlign: "center" }}>{minutosPorKm(item)}</span>
                    <span style={{ width: "90px", textAlign: "right" }}>{currencyFormatter(dieselGasto(item))}</span>
                    <span style={{ width: "80px", textAlign: "right" }}>
                      {currencyFormatter(parseFloat(`${item.diarias}`) * qtdDiarias(item))}
                    </span>
                    <span style={{ width: "80px", textAlign: "right" }}>{currencyFormatter(salarioDia(item, "motorista"))}</span>
                    <span style={{ width: "90px", textAlign: "right" }}>
                      {currencyFormatter(
                        salarioDia(item, "ajudante") +
                        totalDiaAjudantes(item)
                      )}
                    </span>
                    <span style={{ width: "110px", textAlign: "center" }}>{minutesToHours(minutosExtras(item, "motorista"))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(valorHrExtra(item, minutosExtras(item, "motorista"), "motorista"))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>
                      {currencyFormatter(
                        valorHrExtra(item, minutosExtras(item, "ajudante"), "ajudante") +
                        totalExtraAjudantes(item)
                      )}
                    </span>
                    <span style={{ width: "110px", textAlign: "right" }}>
                      {currencyFormatter(
                        valorHrExtra(item, minutosExtras(item, "motorista"), "motorista") +
                        valorHrExtra(item, minutosExtras(item, "ajudante"), "ajudante") +
                        totalExtraAjudantes(item)
                      )}
                    </span>
                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(custoFreelancers(item))}</span>

                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(parseFloat(`${item.valor_pedagio}`))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(parseFloat(`${item.valor_balsa}`))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(parseFloat(`${item.diversos}`))}</span>

                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(totalGasto(item))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(custoKmRodado(item))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>{currencyFormatter(custoPorPedido(item))}</span>
                    <span style={{ width: "110px", textAlign: "right" }}>{porcCusto(item).toFixed(2)}%</span>

                  </div>
                ))}
              </div>

            </div>

          </div>

          <Pagination maxPage={maxPage} page={page} setPage={setPage} />

        </>
      )}

      <Modal isOpen={modalVeiculo} style={defaultModalStyle}>
        <VeiculosModal closeModal={() => setModalVeiculo(false)} handleSelect={(e) => handleSelectVeiculo(e)} />
      </Modal>

      <Modal isOpen={modalMotorista} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalMotorista(false)} handleSelect={(e) => handleSelectMotorista(e)} />
      </Modal>

      <Modal isOpen={modalAjudante} style={defaultModalStyle}>
        <PessoasModal closeModal={() => setModalAjudante(false)} handleSelect={(e) => handleSelectAjudante(e)} />
      </Modal>

      <Modal isOpen={modalDetalhe} style={defaultModalStyle}>
        <DetalheEntregaModal closeModal={() => setModalDetalhe(false)} entrega={detalheEntrega} />
      </Modal>

    </div>
  )
}